import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
	Box,
	Typography,
	Button,
	CircularProgress,
	List,
	ListItemText,
} from "@mui/material";

function SchoolInfo({ info, fetchStatus, error, fetchData, loadingFetch }) {
	const advisorsCount = useSelector(state => state.advisors.length);
	const [colors, setColors] = useState();

	useEffect(() => {
		fetchData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (Object.keys(info).length > 0) {
			info.color && setColors(JSON.parse(info.color));
		}
	}, [info]);

	return (
		<>
			<Typography fontSize={22} fontWeight={"bolder"} my={1}>
				اطلاعات مدرسه
			</Typography>
			{loadingFetch ? (
				<Box className="d-flex-column">
					درحال دریافت اطلاعات
					<CircularProgress color="secondary" sx={{ my: 2 }} />
				</Box>
			) : fetchStatus === 0 ? (
				<List>
					{[
						{ id: 1, title: "نام مدرسه : ", desc: info.name },
						{ id: 2, title: "شهر : ", desc: info.city },
						{ id: 3, title: "آدرس : ", desc: info.address },
						{ id: 4, title: "شماره تماس : ", desc: info.tel },
						{ id: 5, title: "پست الکترونیکی : ", desc: info.mail },
						{ id: 6, title: "وبسایت : ", desc: info.website },
						{ id: 7, title: "تلگرام : ", desc: info.telegram },
						{ id: 8, title: "اینستاگرام : ", desc: info.instagram },
						{ id: 9, title: "تعداد مشاورین : ", desc: advisorsCount },
						{ id: 10, title: "دامنه : ", desc: info.domain },
						{ id: 11, title: "توضیحات : ", desc: info.description },
					].map(item => (
						<ListItemText
							key={item.id}
							primary={
								<Typography mb={0.2} fontWeight={"bold"} fontSize={18}>
									{item.title}
								</Typography>
							}
							secondary={
								<Typography
									fontSize={16}
									sx={{
										border: "1px solid black",
										minHeight: "25px",
										display: "flex",
										alignItems: "center",
										p: 1,
										borderRadius: "5px",
									}}>
									{item.desc || "نامشخص"}
								</Typography>
							}
							sx={{ mb: 2 }}
						/>
					))}
					{colors && (
						<Box
							display={"flex"}
							justifyContent={"space-around"}
							alignItems={"center"}
							flexWrap={"wrap"}>
							<Typography flex={0.5} mb={0.2} fontWeight={"bold"} fontSize={18}>
								تم رنگی :
							</Typography>
							<Box flex={1} display={"flex"} flexWrap={"wrap"}>
								{[
									{ title: "رنگ اول", color: colors.primary },
									{ title: "رنگ دوم", color: colors.secondary },
									{ title: "رنگ متن", color: colors.text },
									{ title: "رنگ پس زمینه", color: colors.background },
								].map((item, index) => (
									<Box key={index} className="d-flex-column" width={"50%"} mt={0.5}>
										{item.title}
										<Box
											sx={{
												width: "70px",
												height: "70px",
												backgroundColor: item.color,
												border: "2px solid black",
												borderRadius: "5px",
											}}
										/>
									</Box>
								))}
							</Box>
						</Box>
					)}
				</List>
			) : (
				<Box className="d-flex-column" mb={2}>
					<Typography mb={1}>{error.header}</Typography>
					<Typography mb={2}>{error.message}</Typography>
					<Button
						onClick={fetchData}
						variant="contained"
						color="secondary"
						sx={{ color: "white" }}>
						تلاش مجدد
					</Button>
				</Box>
			)}
		</>
	);
}

export default SchoolInfo;
